export const isRoadmapRoute = (routeName: string | undefined): boolean => {
	if (routeName === undefined) {
		return false;
	}

	return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};
